import { AxiosError } from "axios";

import { LogOperation } from "../../utils/entities/logOperation";
import api from "../api";
import { returnResponse } from "../utils";

export const hearingFileTypeAttendantRole = {
  getAllRelationsHearingFileTypeAttendantRole: async (
    customerId: number,
    hearingFileType: number,
  ) => {
    if (!customerId || !hearingFileType) {
      return {
        status: false,
        message: "Não é possivel vincular sem o customer e o hearingFileType",
      };
    }

    try {
      const { data } = await api.get(
        `/v1/HearingFileTypeAttendantRole/GetHearingFileTypeAttendantRoleRelation`,
        {
          params: {
            customerId,
            hearingFileType,
          },
        },
      );

      return {
        success: true,
        data: data,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: error?.response?.data.message,
        });

        return {
          success: false,
          severity,
          status,
          body: message ? message : "Error",
          data,
        };
      }

      return {
        status: false,
        message: "Error",
        data: null,
        severity: "error",
      };
    }
  },

  vincularHearingFileTypeEAttendantRole: async (
    customerId: number,
    hearingFileTypeId: number,
    attendantRoleId: number,
  ) => {
    if (!customerId || !hearingFileTypeId || !attendantRoleId) {
      return {
        status: false,
        message: "Não é possivel vincular sem customer e hearingFileType",
      };
    }

    try {
      const { data } = await api.post(`/v1/HearingFileTypeAttendantRole/Add`, {
        customerId,
        hearingFileTypeId,
        attendantRoleId,
        device: LogOperation.getDevice(),
        ip: LogOperation.getMachineIP(),
        logPoliceUnitId: LogOperation.getPoliceUnitId(),
        logUserId: LogOperation.getUserId(),
      });
      return {
        success: true,
        body: data.message,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: error?.response?.data.message,
        });

        return {
          success: false,
          severity,
          status,
          body: message ? message : "Error",
          data,
        };
      }

      return {
        status: false,
        message: "Error",
        data: null,
        severity: "error",
      };
    }
  },

  deletarVinculoHearingFileTypeEAttendantRole: async (id: number) => {
    if (!id) {
      return {
        status: false,
        message: "Não é possivel deletar",
      };
    }

    try {
      await api.delete(`/v1/HearingFileTypeAttendantRole/Delete`, {
        params: {
          id,
        },
      });

      return {
        success: true,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: error?.response?.data.message,
        });

        return {
          success: false,
          severity,
          status,
          body: message ? message : "Error",
          data,
        };
      }

      return {
        status: false,
        message: "Error",
        data: null,
        severity: "error",
      };
    }
  },

  getAll: async (customerId: number, active: number) => {
    const situation =
      active === undefined || active === 2 ? "" : `&active=${active}`;
    try {
      const { data } = await api.get<any>(
        `/v1/HearingFileType/GetAllByCustomerId?customerId=${customerId}${situation}`,
      );

      return {
        status: true,
        data: data,
        message: data.message,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const messages = error?.response?.data?.errors;
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "An unexpected error occurred",
        });

        return {
          severity,
          status,
          message: message ? message : "Error",
          data,
        };
      }
    }
  },
};
